import React from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coldarkCold } from "react-syntax-highlighter/dist/esm/styles/prism";

function RequestSamples({ selectedEndpoint }) {
  const [tab, setTab] = React.useState(0);

  const samples = selectedEndpoint?.code_samples || [];

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
  };

  return (
    <Paper elevation={0} sx={{ background: "#ECF2FE", p: 2, mt: 2 }}>
      <Tabs
        value={tab}
        onChange={(e, val) => setTab(val)}
        variant="scrollable"
      >
        {samples.map((s, i) => (
          <Tab key={i} label={s.languageName ||` Sample ${i + 1}`} sx={{ p: 0 }} />
        ))}
      </Tabs>
      <Box sx={{ position: "relative", mt: 1 }}>
        <Tooltip title="Copy">
          <IconButton
            onClick={() => handleCopy(samples[tab].code)}
            sx={{ position: "absolute", right: 0, top: 0, display: "flex", alignItems: "center", gap: "3px" }}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_108_1337)">
              <path d="M6 10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6L10.6667 6C12.5523 6 13.4951 6 14.0809 6.58579C14.6667 7.17157 14.6667 8.11438 14.6667 10V10.6667C14.6667 12.5523 14.6667 13.4951 14.0809 14.0809C13.4951 14.6667 12.5523 14.6667 10.6667 14.6667H10C8.11438 14.6667 7.17157 14.6667 6.58579 14.0809C6 13.4951 6 12.5523 6 10.6667L6 10Z" stroke="#686868" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.3332 6.00001C11.3316 4.02862 11.3018 3.00748 10.7279 2.3083C10.6171 2.17327 10.4933 2.04946 10.3583 1.93865C9.62074 1.33334 8.52491 1.33334 6.33325 1.33334C4.1416 1.33334 3.04577 1.33334 2.3082 1.93865C2.17318 2.04946 2.04937 2.17327 1.93856 2.30829C1.33325 3.04586 1.33325 4.14169 1.33325 6.33334C1.33325 8.525 1.33325 9.62082 1.93856 10.3584C2.04937 10.4934 2.17318 10.6172 2.3082 10.728C3.00739 11.3018 4.02852 11.3317 5.99992 11.3333" stroke="#686868" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_108_1337">
              <rect width="16" height="16" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <Typography
                sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "#686868",}}>Copy
            </Typography>
          </IconButton>
        </Tooltip>
        <Box
          component="pre"
          sx={{
            background: "#fff",
            color: "#000",
            overflowX: "auto",
            borderRadius: 1,
            fontSize: 14,
            padding: "0 20px",
            m: 0,
          }}
        >
          <SyntaxHighlighter
            language={
              (() => {
                const lang = samples[tab]?.languageName?.toLowerCase();
                if (lang === "curl") return "bash";
                if (lang === "node.js") return "javascript";
                return lang || "bash";
              })()
            }
            style={coldarkCold}
            wrapLongLines
            customStyle={{
              padding: 0,
              borderRadius: "10px",
              fontSize: "14px",
              background: "#FFFFFF",
            }}
          >
            {samples[tab]?.code}
          </SyntaxHighlighter>
        </Box>
      </Box>
    </Paper>
  );
}

export default RequestSamples;